import { ApiResponse } from "../common/type";
import axiosClient from "./axiosClient";

interface LaptopListData {
    items: any[];
    meta: {
        totalItems: number;
        itemCount: number;
        itemsPerPage: number;
        totalPages: number;
        currentPage: number;
    };
}

const laptopApi = {
    getAllLaptop: async (params: any): Promise<ApiResponse<LaptopListData>> => {
        return axiosClient.get<ApiResponse<LaptopListData>>("/laptop", { params }).then(r => r.data);
    },
    getInformationLaptop: async (id: string): Promise<ApiResponse<any>> => {
        return axiosClient.get<ApiResponse<any>>(`/laptop/${id}`).then(r => r.data);
    },
    createLaptop: async (data: any): Promise<ApiResponse<any>> => {
        return axiosClient.post("/laptop", data).then(r => r.data);
    },
    updateLaptop: async (data: any, id: string): Promise<ApiResponse<any>> => {
        return axiosClient.patch(`/laptop/${id}`, data).then(r => r.data);
    },
    deleteLaptop: async (id: string): Promise<ApiResponse<any>> => {
        return axiosClient.delete(`/laptop/${id}`).then(r => r.data);
    },
};

export default laptopApi;